import { memo } from 'react';
import SchedulerDisplay from '../Job/Scheduler/SchedulerDisplay';

const Dashboard = memo(function Dashboard() {
  return (
    <div className='w-full'>
      <SchedulerDisplay />
    </div>
  );
});

export default Dashboard;
